export default __webpack_public_path__ + "static/media/messageLbIcon.553a019f.svg";